import { Payable } from '@klear/payable/payable'
import { paymentFromPayable } from '@klear/payable/payment-from-payable'
import { Payment } from '@klear/payment/payment'

export type PaymentViewSource = Payable | Payment

export type PaymentViewModel = {
  payment: Payment
  number?: string
  linkedPayableId?: number
  displayStatus: string
}

function linkedPayableIdFromPayment(payment: Payment): number | undefined {
  if (payment.payableId != null && payment.payableId > 0) return payment.payableId
  if (payment.orderEventId != null && payment.orderEventId > 0) return payment.orderEventId
  return undefined
}

export function materializePaymentViewModel(source: PaymentViewSource): PaymentViewModel {
  if (source instanceof Payable) {
    return {
      payment: paymentFromPayable(source),
      number: source.number,
      linkedPayableId: source.id != null && source.id > 0 ? source.id : undefined,
      displayStatus: source.paymentStatus ?? source.status
    }
  }

  return {
    payment: source,
    linkedPayableId: linkedPayableIdFromPayment(source),
    displayStatus: source.status
  }
}
